import styled from 'styled-components';
import addAlpha from 'utils/addAlpha';

export const Placeholder = styled.span`
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => addAlpha(theme.colors.gray2, 0.75)};
  border-radius: 0.375rem;
`;
